var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pb-8"},[_c('v-row',_vm._l((_vm.otherProducts),function(item){return _c('v-col',{key:item.id,attrs:{"md":"4","sm":"6","xs":"12"}},[_c('div',{staticClass:"card-menu"},[_c('CardProduct',{attrs:{"product":item}})],1)])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }